export default class EditNoteDialogController {
    /** @ngInject */
    constructor(DialogService, note, NotesApi, ToastService, Loader, ErrorsService) {
        this.DialogService = DialogService;
        this.NotesApi = NotesApi;
        this.note = note;
        this.content = this.note.content;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    onInit() {
        this.genericErrors = this.ErrorsService.getGenericErrors();
    }

    updateNote() {
        if (!this.content.length) return;
        this.Loader.show();

        this.NotesApi.editNote(this.note.id, this.content)
            .then(() => {
                this.note.content = this.content;
                this.Loader.hide();
                this.ToastService.showSimpleTranslated('comment_was_updated');
                this.cancel();
            });
    }

    cancel() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/notes/dialog/edit-note/edit-note.controller.js